import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { ViewModel } from '../viewmodels/view-model';
import { BackendServiceBase } from './backend-service-base';
import { Configuration } from './config';
import { ConfigService } from './config.service';
import { SpinnerService } from './spinner/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class BlobBackendService extends BackendServiceBase {
  apiUrl: string;

  constructor(
    private http: HttpClient,
    private spinner: SpinnerService,
    private configService: ConfigService,
  ) {
    super();

    const configuration: Configuration = configService.getConfiguration();
    if (configuration && configuration.apiBaseUrl) {
      this.apiUrl = configuration.apiBaseUrl;
    }
  }

  getByObject<T extends ViewModel>(
    genericType: new () => T,
    object: T,
  ): Observable<Blob> {
    const genericTypeInfo: T = new genericType();

    this.spinner.show();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const options = {
      method: "POST",
      headers,
      responseType: 'blob' as 'blob',
    };

    return this.http
      .post(
        this.apiUrl + '/' + genericTypeInfo.apiRoute,
        JSON.stringify(object.json()),
        options,
      ).pipe(
        map(res => res),
        catchError(err =>
          this.handleError(
            `Could not retrieve ${genericTypeInfo.friendlyTypeNameSingular} with object.`,
            err,
          ),
        ),
        finalize(() => this.spinner.hide()),) as Observable<Blob>;
  }

  uploadBlob(controller: string, blob: Blob): Observable<any> {
    this.spinner.show();

    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream',
    });

    const options = { method: "POST", headers };

    return this.http
      .post(this.apiUrl + '/' + controller, blob, options).pipe(
        finalize(() => this.spinner.hide()));
  }
}
